// Used in distributor.component.html, teacher.component.html, student.component.html, lmsi.component.html

// Angular
import {
    Component,
    OnInit,
    OnDestroy,
    ChangeDetectionStrategy,
} from "@angular/core";
import { Idle, DEFAULT_INTERRUPTSOURCES, AutoResume } from "@ng-idle/core";
import { MatDialog } from "@angular/material/dialog";

// Component
import { IdleCheckerDialogComponent } from "#components/dialog-boxes/idle-checker-dialog/idle-checker-dialog.component";

// RXJS/Store
import { Store } from "@ngrx/store";
import * as fromProfileStore from "#login/store";
import { Subject } from "rxjs";
import { takeUntil, first } from "rxjs/operators";

@Component({
    selector: "idle-checker",
    templateUrl: "./idle-checker.component.html",
    styleUrls: ["./idle-checker.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IdleCheckerComponent implements OnInit, OnDestroy {
    idleState = "Not started.";
    private ngUnsubscribe = new Subject();

    constructor(
        private idle: Idle,
        public dialog: MatDialog,
        private profileStore: Store<fromProfileStore.UserState>
    ) {}

    ngOnInit() {
        // sets an idle timeout, amount of time before warning message appears
        this.idle.setIdle(3000); // 50min
        // sets a timeout period, amount of time indicated in warning message before auto logout occurs
        this.idle.setTimeout(300); // 5min
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onIdleEnd
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                this.reset();
            });

        this.idle.onIdleStart
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                if ((<any>window).isDemo) {
                    this.reset();
                    return;
                }
                this.idleState = "You've gone idle!";

                if (this.dialog.openDialogs.length > 0) {
                    this.dialog.closeAll();
                }

                // stops the interruption checker but the countdown still works
                this.idle.setAutoResume(AutoResume.notIdle);

                this.dialog
                    .open(IdleCheckerDialogComponent, {
                        disableClose: true,
                        hasBackdrop: true,
                        maxWidth: "25em",
                    })
                    .afterClosed()
                    .pipe(first(), takeUntil(this.ngUnsubscribe))
                    .subscribe((data: boolean) => {
                        if (data || data === undefined) {
                            // keep user logged in, reset timeout
                            this.reset();
                        } else {
                            this.profileStore.dispatch(
                                fromProfileStore.userLogout({ signout: true })
                            );
                        }
                    });
            });

        this.reset();
    }

    ngOnDestroy(): void {
        this.idle.stop();

        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    reset() {
        this.idle.watch();
        this.idleState = "Started.";
    }
}
